<template>
  <v-navigation-drawer
    :value="isOpenLeadDrawer"
    width="50%"
    right
    fixed
    temporary
    style="transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
    @input="inputLeadDetailsDrawer"
  >
    <BaseToolbar
      :title="$t('leads.details.title')"
      backgroundColor="#2661FF"
      type-title="icon"
      icon="visibility"
      @close="toggleLeadDetailsDrawer(false)"
    />

    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card class="rounded-lg custom_card">
            <v-card-title class="d-flex align-center">
              <span
                class="subtitle-2"
                style="position: absolute; top: 10px; right: 15px;"
              >
                ID: <strong class="text_color">{{ lead.id }}</strong>
              </span>
              <v-list-item class="pa-0">
                <v-list-item-avatar
                  :color="randomizedColor()"
                  class="mr-4"
                  size="30"
                >
                  <span class="white--text caption text-uppercase">
                    {{
                      getInitials(lead.first_name, lead.last_name, lead.email)
                    }}
                  </span>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-medium">
                    {{ `${lead.first_name || ""} ${lead.last_name || ""}` }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="grey--text text--darken-2">
                    {{ lead.email }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-title>
            <div class="d-flex justify-center align-center">
              <div
                class="rounded-lg"
                style="width: 90%; height: 1px; background-color: #dadbdf;"
              ></div>
            </div>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="12">
                  <v-card class="rounded-lg custom_card">
                    <v-card-title class="body-1 font-weight-medium">
                      <span>
                        {{ $t("leads.details.score.title") }}
                      </span>
                      <v-spacer></v-spacer>
                      <span class="text_color">
                        {{ lead.score }}
                      </span>
                    </v-card-title>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card class="rounded-lg custom_card">
                    <v-card-title class="body-1 font-weight-medium">
                      {{ $t("leads.details.organization.title") }}
                    </v-card-title>
                    <v-card-text>
                      <v-row no-gutters>
                        <v-col cols="12">
                          <v-text-field
                            v-model="lead.organization.name"
                            :label="$t('leads.details.organization.name')"
                            outlined
                            class="rounded-lg"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="lead.organization.url"
                            label="URL"
                            outlined
                            class="rounded-lg"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="lead.organization.contact_info"
                            :label="$t('leads.details.organization.contact')"
                            outlined
                            class="rounded-lg"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="leadOrganizationCurrency"
                            :label="$t('leads.details.organization.currency')"
                            outlined
                            class="rounded-lg"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="leadOrganizationStatus"
                            :label="$t('leads.details.organization.status')"
                            outlined
                            class="rounded-lg"
                            dense
                            readonly
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6">
                  <v-card class="rounded-lg custom_card">
                    <v-card-title class="body-1 font-weight-medium">
                      {{ $t("leads.details.transactions.title") }}
                      <v-spacer></v-spacer>
                      <span class="text_color">
                        {{ lead.donations.length }}
                      </span>
                    </v-card-title>
                    <!-- TODO: Complete this with transactions data -->
                    <!-- <v-card-text>
                      <v-row no-gutters>
                        <v-col cols="12">
                        </v-col>
                      </v-row>
                    </v-card-text> -->
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import BaseToolbar from "@/components/BaseToolbar";
import leadMixin from "@/mixins/leads";
import organizationMixin from "@/mixins/organizations";

export default {
  name: "LeadDetailsDrawer",
  components: {
    BaseToolbar
  },
  mixins: [leadMixin, organizationMixin],
  computed: {
    ...mapState({
      lead: ({ leads: { lead } }) => lead,
      isOpenLeadDrawer: ({ leads: { isOpenLeadDrawer } }) => isOpenLeadDrawer,
      currencies: ({ countries: { currencies } }) => currencies
    }),
    leadOrganizationCurrency() {
      return this.getCurrencyNameById();
    },
    leadOrganizationStatus() {
      const { lead } = this;
      const organizationStatus = this.getOrganizationStatus(
        lead.organization.status
      );
      return organizationStatus.text;
    }
  },
  methods: {
    ...mapMutations({
      setLead: "leads/setLead",
      toggleLeadDetailsDrawer: "leads/toggleLeadDetailsDrawer"
    }),
    randomizedColor() {
      const letters = "0123456789ABCDEF";
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    getCurrencyNameById() {
      const { lead, currencies } = this;

      if (lead.organization.currency_id) {
        const currency = currencies.find(
          currency => currency.id === lead.organization.currency_id
        );
        return currency ? currency.name : "";
      }
      return "";
    },
    inputLeadDetailsDrawer(arg) {
      if (!arg) {
        this.toggleLeadDetailsDrawer(false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom_card {
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #2661ff;
}
</style>
